import React from 'react';
import { useLocation } from 'react-router-dom';
import { GROWINTEL_PATHS } from '../../constants/GrowintelPaths';
import NotFoundPage from '../../pages/404';

type Props = {
  children: React.ReactNode;
};

// Define valid paths based on the GROWINTEL_PATHS constants
const validPaths = Object.values(GROWINTEL_PATHS).flatMap((path) => {
  // Handle nested objects like DETAIL
  if (typeof path === 'object') {
    return Object.values(path);
  }
  return path;
});

export default function RouteHandler({ children }: Props) {
  const location = useLocation();
  const currentPath = location.pathname;

  // Check if the current path is a valid path or a subpath of a valid path
  const isValidPath = validPaths.some((path) => {
    // Convert path patterns with parameters (like /grow-intel/branch/:id) to regex
    const pathRegex = new RegExp(`^${path.replace(/:[^/]+/g, '[^/]+')}$`);
    return pathRegex.test(currentPath);
  });

  // If path is not valid, show 404 page
  if (!isValidPath && currentPath.startsWith('/grow-intel')) {
    return <NotFoundPage />;
  }

  // Otherwise, render children components
  return <>{children}</>;
}
